import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default function PrevencionSAGRILAFT() {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12} md={10}>
          <h4 className="mt-4" style={{
                    color: "#7AC70C",
                    fontWeight: "bold",
                    fontSize: "1.4rem",
                  }}>XV. PREVENCIÓN DE LAVADO DE ACTIVOS Y FINANCIACIÓN DEL TERRORISMO, FINANCIACIÓN PARA LA PROLIFERACIÓN DE ARMAS DE DESTRUCCIÓN MASIVA SAGRILAFT, Y PROGRAMA DE TRANSPARENCIA Y ÉTICA EMPRESARIAL</h4>
          <br></br>          
          <ol style={{ listStyleType: 'lower-alpha', paddingLeft: '20px' }}>
            <br></br>
            <li>
              <p>
                <strong>Reconocimiento y Aceptación:</strong> El Usuario/ Cliente Corporativo. reconoce, entiende y acepta de manera voluntaria e inequívoca que Parking, en cumplimiento de la normativa vigente Colombiana, puede dar por terminado el servicio de forma unilateral cuando el Usuario haya sido incluido en listas nacionales e internacionales tales como ONU, FINCEN, OFAC (Office of Foreign Assets Control), y cualquier otra lista vinculante para Colombia según las disposiciones de la Unidad de Información y Análisis Financiero (UIAF) y la Superintendencia de Sociedades.
              </p>
            </li>
            <li>
              <p>
                <strong>Declaración de Origen de Fondos:</strong> El Usuario/ Cliente Corporativo. declara y garantiza que sus recursos tienen un origen lícito y provienen directamente del desarrollo de su actividad económica y ocupación lícitas. El Usuario/ Cliente Corporativo. se compromete a no utilizar el servicio de Parking para actividades ilícitas, incluyendo, pero no limitándose a, el lavado de activos, la financiación del terrorismo, corrupción, soborno nacional, soborno transnacional o cualquier otra actividad contraria a la ley.
              </p>
            </li>
            <li>
              <p>
                <strong>Obligaciones del Usuario/Cliente Corporativo:</strong> El Usuario/Cliente Corporativo se comprometen a:
              </p>
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  <p>
                    Proporcionar información veraz y completa al momento de su registro y durante la utilización del servicio.
                  </p>
                </li>
                <li>
                  <p>
                    Actualizar de manera oportuna cualquier cambio en la información suministrada que sea relevante para la relación contractual.
                  </p>
                </li>
                <li>
                  <p>
                    Abstenerse de realizar transacciones que puedan estar vinculadas a actividades ilícitas, incluyendo pero no limitándose a lavado de activos, financiación del terrorismo, corrupción o soborno.
                  </p>
                </li>
                <li>
                  <p>
                    Cumplir con las políticas de SAGRILAFT y PTEE implementados por Parking, así como con cualquier solicitud de información en el marco del monitoreo y prevención de riesgos.
                  </p>
                </li>
                <li>
                  <p>
                    Informar inmediatamente a Parking sobre cualquier hecho o circunstancia que pueda indicar que los recursos utilizados en la transacción no tienen un origen lícito.
                  </p>
                </li>
              </ul>
            </li>
            <li>
              <p>
                <strong>Facultades de Parking:</strong> Parking se reserva el derecho de:
              </p>
              <ul style={{ paddingLeft: '20px' }}>
                <li>
                  <p>
                    Solicitar documentación o realizar verificaciones necesarias para comprobar la licitud del origen de los recursos del Usuario/ Cliente Corporativo.
                  </p>
                </li>
                <li>
                  <p>
                    Consultar al Usuario/ Cliente Corporativo. en listas restrictivas nacionales e internacionales para evaluar riesgos y garantizar el cumplimiento normativo.
                  </p>
                </li>
                <li>
                  <p>
                    Reportar a las autoridades competentes cualquier actividad sospechosa que pueda constituir una infracción a las normas de prevención de lavado de activos y financiación del terrorismo, corrupción, soborno u otros delitos.
                  </p>
                </li>
                <li>
                  <p>
                    Parking se reserva el derecho de suspender o terminar unilateralmente el servicio en caso de detectar cualquier actividad sospechosa o indicios de lavado de activos, financiación del terrorismo, corrupción, soborno u otros delitos. Del mismo modo, podrá ejercer esta facultad si llega a tener conocimiento de que el Usuario/ Cliente Corporativo. se encuentra involucrado en una investigación de cualquier tipo (penal, administrativa, etc.) relacionada con actividades ilícitas.
                  </p>
                </li>
              </ul>
            </li>

            <li>
              <p>
                <strong>f.	Cumplimiento Normativo: </strong><br></br> <br></br>Parking se compromete a cumplir con todas las obligaciones impuestas por la legislación colombiana en materia de prevención de lavado de activos y financiación del terrorismo, incluyendo la implementación de un Sistema de Autocontrol y Gestión del Riesgo Integral (SAGRILAFT), el Programa de Transparencia y Ética Empresarial (PTEE) y a seguir las recomendaciones del Grupo de Acción Financiera Internacional (GAFI) y de la Unidad de Información y Análisis Financiero (UIAF).
              </p>
            </li>
          </ol>
        </Col>
      </Row>
    </Container>
  );
}